/**
 * テキストエリア
 */
import React, { forwardRef } from 'react';

type Props = {
  id?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  maxLength?: number;
  height?: string;
  resizable?: 'none' | 'vertical' | 'horizontal' | 'both';
  error?: boolean;
};

const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      id,
      value,
      placeholder,
      onChange,
      maxLength,
      height = '120px',
      resizable = 'none',
      error = false,
    },
    ref,
  ) => {
    return (
      <textarea
        ref={ref}
        id={id}
        className={`size-full rounded border border-solid border-gray-250 p-[16px] text-sm placeholder:text-gray-400 focus:shadow-none focus:outline-none lg:text-base
        ${error ? ' border-warning-500 bg-warning-200/70' : ''}
        ${resizable}
      `}
        value={value || ''}
        placeholder={placeholder}
        onChange={onChange}
        maxLength={maxLength}
        style={{ height }}
      ></textarea>
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
